import { useCallback, useEffect, useState } from "react";
import PendingAuthService from "../../../services/approvals.service";
import { useNavigate } from "react-router";
import { Breadcrumb, Card, Empty, Tabs, Button } from "antd";
import SelectAllCard from "../../../components/pending-approvals/selectAll";
import download from "../../../assests/icons/download_icon.png";
import { AiOutlineLeft } from "react-icons/ai";
import { ReactComponent as TitleIcon } from "../../../assests/images/transfer.svg";
import { useTranslation } from "react-i18next";
import ChequeBookRequestCard from "../../../components/pending-approvals/chequeBookRequest";
import LoanRepaymentCard from "../../../components/pending-approvals/loanRepayment";
import LoanRepayHistoryGrid from "../../../components/pending-approvals/history-grids/loanRepayGrid";
import LoanRepayHistoryList from "../../../components/pending-approvals/history-lists/loanRepayList";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";

export default function HistoryLoanRepaymentCard() {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const { t } = useTranslation();
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  useEffect(() => {
    getPendingRecords();
  }, []);

  const getPendingRecords = useCallback(async () => {
    try {
      const response = await PendingAuthService.loanRepaymentGetRecords({
        listType: "A",
      });
      if (response.status === 200) {
        setDataSource(response.data["data"]);
      }
    } catch (error) {}
  }, []);

  const handleDownload = useCallback(async () => {
    try {
      const reqParams = {
        listType: "A",
      };
      await PendingAuthService.loanRepaymentDownload(reqParams);
    } catch (err) {}
  }, []);

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/history")}>
              {t("navigation.history", {
                defaultValue: "History",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {" "}
              {t("navigation.loan_repayment", {
                defaultValue: "Investment Repayment",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {" "}
              {t("navigation.loan_repayment", {
                defaultValue: "Investment Repayment",
              })}
            </h3>
          </div>
          <div className=" col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end">
            {dataSource.length === 0 ? null : (
              <Button
                type="default"
                className="btn-primary"
                onClick={handleDownload}
              >
                <img
                  alt="download"
                  src={download}
                  height={20}
                  style={{ paddingRight: "15px" }}
                />
                {t("buttons.download_btn", { defaultValue: "Download" })}
              </Button>
            )}
          </div>
        </div>
      </Card>

      <Card className="application-card">
        {showGridAccount === "GRID" && (
          <LoanRepayHistoryGrid dataSource={dataSource} />
        )}
        {showGridAccount === "LIST" && (
          <LoanRepayHistoryList dataSource={dataSource} />
        )}
      </Card>
    </>
  );
}
